import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface ListHeaderProps {
  /** Titre de la liste */
  title?: string;
  /** Icône du titre */
  icon?: LucideIcon;
  /** Nombre total d'éléments */
  total?: number;
  /** Afficher le compteur ? */
  showCount?: boolean;
  /** Actions du header (boutons, etc.) */
  actions?: ReactNode;
  /** Description/subtitle */
  description?: string;
  /** Toggle de vue (grille/tableau) */
  viewToggle?: ReactNode;
  /** Contenu custom à gauche (remplace titre + icône + count) */
  customHeaderLeft?: ReactNode;
  /** Position du toggle de vue : 'left' (défaut) ou 'right' (à côté des actions) */
  viewTogglePosition?: 'left' | 'right';
}

export function ListHeader({
  title,
  icon: Icon,
  total,
  showCount = true,
  actions,
  description,
  viewToggle,
  customHeaderLeft,
  viewTogglePosition = 'left',
}: ListHeaderProps) {
  return (
    <div className="tw-mb-6">
      <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-start sm:tw-items-center tw-justify-between tw-gap-3">
        <div>
          <div className="tw-flex tw-items-center tw-gap-3">
            {viewToggle && viewTogglePosition === 'left' && <div>{viewToggle}</div>}
            {customHeaderLeft ? (
              customHeaderLeft
            ) : (
              <>
                {Icon && <Icon className="tw-w-8 tw-h-8 tw-text-affinicar-primary" />}
                <h1 className="tw-text-xl sm:tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-0">
                  {title}
                  {showCount && total !== undefined && (
                    <span className="tw-ml-2 tw-text-gray-500 tw-font-normal">
                      ({total} {total > 1 ? 'éléments' : 'élément'})
                    </span>
                  )}
                </h1>
              </>
            )}
            {viewToggle && viewTogglePosition === 'right' && <div>{viewToggle}</div>}
          </div>
          {description && (
            <p className="tw-mt-2 tw-text-gray-600 tw-text-sm">{description}</p>
          )}
        </div>
        {actions && <div className="tw-flex tw-items-center tw-gap-2 tw-w-full sm:tw-w-auto">{actions}</div>}
      </div>
    </div>
  );
}
